.ux-modal-footer {
  align-items: stretch;
  border-top: 1px solid $color-gray-background;
  display: flex;
  flex: 0 0 auto;
  flex-direction: column;
  justify-content: space-between;
  padding: $dim-30;

  ux-button,
  & > .ux-button {
    flex: 1 0 auto;
  }

  &__spacer {
    flex: 0 0 $dim-15;
  }

  @media (width >= 569px) {
    flex-flow: row-reverse nowrap;

    ux-button,
    & > .ux-button {
      flex: 1 1 50%;
    }

    &__spacer {
      flex: 0 0 $dim-30;
    }
  }
}
